module.exports = __webpack_public_path__ + "static/media/pescadosymariscos_checked.096dd8a5.svg";